import * as DocumentStoreActions from "./document.actions";
import * as DocumentStoreSelectors from "./document.selectors";
import * as DocumentStoreReducer from "./document.reducer";

export { DocumentStoreActions, DocumentStoreSelectors, DocumentStoreReducer };
